import { ChargeAndGoPaymentMethod } from '../../../../../codegen/paymentPartners';
import { PaymentPartnerType } from '../../../../../codegen/vehicles';
import { ServiceCardTypeIcon } from '../../../../../components/icons/ServiceCardTypeIcon';
import { CustomFormattedMessage } from '../../../../../i18n/i18n';

type ChargeAndGoCardRepresentationProps = {
  card: ChargeAndGoPaymentMethod;
};

export const ChargeAndGoCardRepresentation = ({
  card,
}: ChargeAndGoCardRepresentationProps) => {
  return (
    <div className={'display-flex'}>
      <div
        className={'min-width-200'}
        data-testid={'charge-card-form-card-alias'}
      >
        <ServiceCardTypeIcon
          type={PaymentPartnerType.ManChargeAndGoPayment}
          className="height-20 margin-right-10 margin-bottom-0"
        />
        {card.alias ? (
          <span>{card.alias}</span>
        ) : (
          <span className="text-color-gray">
            <CustomFormattedMessage id={'common.card.noAlias'} />
          </span>
        )}
      </div>
      <div className={'margin-left-20'}>{card.cardNumber}</div>
      <div className={'margin-left-20 align'}>
        {card.enabled ? (
          <span className="text-color-success">
            <CustomFormattedMessage id={'common.card.active'} />
          </span>
        ) : (
          <span className="text-color-dark">
            <CustomFormattedMessage id={'common.card.inactive'} />
          </span>
        )}
      </div>
    </div>
  );
};
